import React,{ useState, useEffect } from 'react';
import { BrowserView, MobileView, isMobile } from 'react-device-detect';
import './App.css';

import { Level } from './components/Level';
import { LevelMobile } from './components/LevelMobile';
import { WelcomeDesk } from './components/WelcomeDesk';
import {EndScr} from './components/EndScr';
import {EndScrMobile} from './components/EndScrMobile';
import { Login } from './components/Login';
import getAxiosInstance from "./config/http";
import {SessionEnd} from './components/SessionEnd';
import {SessionEndMobile} from './components/SessionEnd_Mobile';
import { WelcomeDeskMobile } from './components/WelcomeDesk_Mobile';



function App() {
  const [totalPoints, setTotalPoints] = useState(0);
  const [currentLevel, setCurrentlevel] = useState(-2); //default -1 - Welcome Scr
  const [currentSession, setCurrentSession] = useState({});
  const [numChestOpened, setNumChestOpened] = useState(0);
  const [isSessionActive, setIsSessionActive] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  
  const orientation = isMobile ? "mobile" : "";
  
    

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);

  const [levelPrizes, setLevelPrizes] = useState([]);

  // Adding login, register and createSession logic based on strapi request.
  const login = () => async (userData) => {
    const http = getAxiosInstance();
    // console.warn(http.request.data);
    try {
      const { data } = await http.post("/auth/local-simple", userData);
      http.defaults.headers.common["Authorization"] = `bearer ${data.jwt}`;
      return data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  };

  const register = () => async (userData) => {
    const http = getAxiosInstance();
    try {
      const { data } = await http.post("/auth/local-simple/register", userData);
      return data;
    } catch (e) {
      console.log(e);
    }
  };

  const createSession = () => async (requestData) => {
    const http = getAxiosInstance();
    try {
      const { data } = await http.post("/game-sessions", requestData);
      setCurrentSession(data);
      // console.log("currentDATA", data)
      if (!data.finished && !data.didWin && data.gameState !== null && data.gameState.opened.length > 0) {
        setTotalPoints(data.gameState.totalPoints);
        setCurrentlevel(-1);
      } else {
        setCurrentlevel(-1);
      }
      return data;
    } catch (e) {
      throw e;
    }
  };

  // End of adding login, register and createSession.

  // Adding open chest logic based on strapi request.
  const bonusMasterOpen = (params) => async (params) => {
    // console.log(params);
    setIsLoaded(false);
    const http = getAxiosInstance();
    let _levelPrizes = [];
    try {
      const { data } = await http.post(
        "/merkurbet/bonusCvece/open",
        {},
        { params }
      );
      updateTotalPoints(data.gameState.points, data.gameState.totalPoints);
      for (let i=0; i < 3; i++) {
        _levelPrizes.push([data.gameState.points, data.gameState.points, data.gameState.points]);
      }
      setLevelPrizes(_levelPrizes);
      setIsLoaded(true);
      return data;
    } catch (e) {
      console.log(e);
      setIsLoaded(true);
      // setError(e);
      // throw e;
    }
  };
  // End of adding open chest logic.

    // Adding bonus transfer logic based on strapi request.
    const bonusMasterTransfer = () => async () => {
      const http = getAxiosInstance();
      try {
        const { data } = await http.post(
          "/merkurbet/bonusCvece/open",
          {},
          {
            params: {session: currentSession.id}
          }
        );
      } catch (e) {
        console.log(e);
        // setError(e);
        // throw e;
      }
    };
    // End of bonus transfer logic.

  React.useEffect(() => {
    if (currentSession.finished) {
      if (currentSession.didWin) {
        setTotalPoints(currentSession.gameState.totalPoints);
        setCurrentlevel(4);
      } else {
        setIsSessionActive(false);
      }
    } else {
      setIsSessionActive(true);
    }
  }, [currentSession, isSessionActive])

  //Preload animation images
  useEffect(() => {
    let  levelBgImgs;
    // console.log('inIframe',inIframe());
    if (isMobile) {
      levelBgImgs = [
        './images/mobile/level1/img_4.png',
        './images/mobile/level1/img_3.png',
        './images/mobile/level1/img_2.png',
        './images/mobile/level1/img_1.png',
        './images/mobile/level1/img_0.png',
        './images/flower1click/img_0.png',
        './images/flower1click/img_1.png',
        './images/flower1open/img_0.png',
        './images/flower1open/img_1.png',
        './images/flower2click/img_0.png',
        './images/flower2click/img_1.png',
        './images/flower2open/img_0.png',
        './images/flower2open/img_1.png',
        './images/flower3click/img_0.png',
        './images/flower3click/img_1.png',
        './images/flower3open/img_0.png',
        './images/flower3open/img_1.png',
        './images/flower4click/img_0.png',
        './images/flower4click/img_1.png',
        './images/flower4open/img_0.png',
        './images/flower4open/img_1.png',
        './images/flower5click/img_0.png',
        './images/flower5click/img_1.png',
        './images/flower5open/img_0.png',
        './images/flower5open/img_1.png'
      ]

    } else {
      levelBgImgs = [
        './images/welcome_desk/img_4.png',
        './images/welcome_desk/img_3.png',
        './images/welcome_desk/img_2.png',
        './images/welcome_desk/img_1.png',
        './images/welcome_desk/img_0.png',
        './images/flower1click/img_0.png',
        './images/flower1click/img_1.png',
        './images/flower1open/img_0.png',
        './images/flower1open/img_1.png',
        './images/flower2click/img_0.png',
        './images/flower2click/img_1.png',
        './images/flower2open/img_0.png',
        './images/flower2open/img_1.png',
        './images/flower3click/img_0.png',
        './images/flower3click/img_1.png',
        './images/flower3open/img_0.png',
        './images/flower3open/img_1.png',
        './images/flower4click/img_0.png',
        './images/flower4click/img_1.png',
        './images/flower4open/img_0.png',
        './images/flower4open/img_1.png',
        './images/flower5click/img_0.png',
        './images/flower5click/img_1.png',
        './images/flower5open/img_0.png',
        './images/flower5open/img_1.png'
      ]

    }
    
    cacheImages(levelBgImgs);
    
    //setIsLoading(false);
    return () => {
      //second;
    };
  }, []);
  const cacheImages = async (levelBgImgs) => {
    const promises = await levelBgImgs.map((src) => {
        return new Promise(function (resolve, reject) {
          const img= new Image();
          img.src = src;
          img.onload = resolve();
          img.onerror = reject();
          // console.log("img src: ", src);
        })
    })
    await Promise.all(promises);
    //setIsLoading(false);
  }
  useEffect(() => {
    const timer = setTimeout(() => {
        //setIsLoading(false);
    }, 3000);
    return () => clearTimeout(timer);

  }, []);
  

  const animatePoints = (_points) => {
    let _toPoints = totalPoints + _points;
  }
  // const updateTotalPoints = () => {
  //   let _points = Number(levelPrizes[currentLevel-1][numChestOpened]);
    
  //   setNumChestOpened(numChestOpened+1);
  //   //animatePoints(_points);
  //   setTotalPoints(Number(totalPoints + _points));
  //   console.log("updateTotalPoints:", _points, totalPoints + _points);
  // }

  const updateTotalPoints = (points, totalPoints) => {
    let _points = Number(points);
    
    setNumChestOpened(numChestOpened+1);
    //animatePoints(_points);
    setTotalPoints(Number(totalPoints));
  }
  const updateLevel = (level) => {
    setCurrentlevel(level);
  }
  const loadNextLevel = () => {
    setIsLoading(true);
    setNumChestOpened(0);
    // console.log(currentLevel);
    (currentLevel > 0) ? setCurrentlevel(currentLevel+1) : setCurrentlevel(2);
    // console.log(currentLevel);
  }

  const inIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return e;
    }
  }

  return (
    <div className={`App ${orientation}`}>
      <header className="App-header">
      </header>
      <main>
        {isLoading && currentLevel < 2 && <div className='loaderIcon'><img src='./images/loader.gif' /></div>}
        <MobileView className='mobile-view'>
          {currentLevel === -2 && inIframe() && <Login updateLevel={updateLevel} login={login()} register={register()} createSession={createSession()} /> }
          {currentLevel === -1 && inIframe() && <WelcomeDeskMobile isLoading={() => {setIsLoading()}}  updateLevel={updateLevel} /> }
          {currentLevel === 0 && inIframe() && <LevelMobile  isLoading={() => {setIsLoading()}} updatePoints={() => {updateTotalPoints()}} levelPrizes={levelPrizes[currentLevel-1]} currentLevel={currentLevel} currentSession={currentSession} bonusMasterOpen={bonusMasterOpen()} bonusMasterTransfer={bonusMasterTransfer()} handleNextLevel={() => { loadNextLevel()}} /> }
          {currentLevel > 1 && inIframe() && <EndScrMobile totalPoints={totalPoints} currentSession={currentSession} handleNextLevel={() => { loadNextLevel()}} bonusMasterTransfer={bonusMasterTransfer()} />}    
        </MobileView>
        <BrowserView className='desktop-view'>
          {currentLevel === -2 && inIframe() && <Login updateLevel={updateLevel} login={login()} register={register()} createSession={createSession()} /> }
          {currentLevel === -1 && inIframe() && <WelcomeDesk isLoading={() => {setIsLoading()}} updateLevel={updateLevel} /> }
          {currentLevel === 0 && inIframe() && <Level  isLoading={() => {setIsLoading()}} updatePoints={() => {updateTotalPoints()}} levelPrizes={levelPrizes[currentLevel-1]} currentLevel={currentLevel} currentSession={currentSession} bonusMasterOpen={bonusMasterOpen()} bonusMasterTransfer={bonusMasterTransfer()} handleNextLevel={() => { loadNextLevel()}} /> }   
          {currentLevel > 1 && inIframe() && <EndScr totalPoints={totalPoints} currentSession={currentSession} handleNextLevel={() => { loadNextLevel()}} bonusMasterTransfer={bonusMasterTransfer()} />} 
        </BrowserView>
      </main>
    </div>
  );
}

export default App;
